import Vue from "vue";
import Router from "vue-router";
import { api } from "@/state/services";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: "/",
  routes: [
    {
      path: "/",
      component: () => import("./views/home"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/login",
      component: () => import("./views/login"),
      meta: { authRequired: false, sponsored: 'any' },
    },
    {
      path: "/login/token/:token",
      component: () => import("./views/login-in"),
      meta: { authRequired: false, sponsored: 'any' },
    },
    {
      path: "/logout",
      redirect: "/login",
    },
    {
      path: "/register",
      component: () => import("./views/register"),
      meta: { authRequired: false, sponsored: 'any' },
    },
    {
      path: "/register/:sponsor",
      component: () => import("./views/register"),
      meta: { authRequired: false, sponsored: 'any' },
    },
    {
      path: "/register/:sponsor/:plan",
      component: () => import("./views/register"),
      meta: { authRequired: false, sponsored: 'any' },
    },
    {
      path: "/password-forgot",
      component: () => import("./views/password-forgot"),
      meta: { authRequired: false, sponsored: 'any' },
    },
    {
      path: "/password-change",
      component: () => import("./views/password-change"),
      meta: { authRequired: false, sponsored: 'any' },
    },
    {
      path: "/account",
      component: () => import("./views/account/account"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/account/indication",
      component: () => import("./views/account/indication"),
      meta: { authRequired: true },
    },
    {
      path: "/account/documents",
      component: () => import("./views/account/documents"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/account/address",
      component: () => import("./views/account/address"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/account/password",
      component: () => import("./views/account/password"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/account/password/security",
      component: () => import("./views/account/password-security"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/account/password/security/:token",
      component: () => import("./views/account/password-security"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/account/pix",
      component: () => import("./views/account/pix"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/plans",
      component: () => import("./views/plans/index"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/plans/order/:id",
      component: () => import("./views/plans/order"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/contracts",
      component: () => import("./views/contracts/list"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/contracts/:id",
      component: () => import("./views/contracts/view"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/extract",
      component: () => import("./views/wallet/extract"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/transfer",
      component: () => import("./views/wallet/transfer"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/pay",
      component: () => import("./views/wallet/pay"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/pay/:id",
      component: () => import("./views/wallet/pay"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/withdrawal",
      component: () => import("./views/wallet/withdrawal"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/wallet/withdrawal/history",
      component: () => import("./views/wallet/withdrawal-history"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/network/clients",
      component: () => import("./views/network/clients"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/network/sponsored",
      component: () => import("./views/network/sponsored"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/network/team",
      component: () => import("./views/network/team"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/network/matriz",
      component: () => import("./views/network/matriz"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/network/matriz/:id",
      component: () => import("./views/network/matriz"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/network/unilevel",
      component: () => import("./views/network/unilevel"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/network/unilevel/:id",
      component: () => import("./views/network/unilevel"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/reports/adesao",
      component: () => import("./views/reports/adesao"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/reports/vendadireta",
      component: () => import("./views/reports/vendadireta"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/reports/recorrencia",
      component: () => import("./views/reports/recorrencia"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/reports/graduation",
      component: () => import("./views/reports/graduation"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/store/orders",
      component: () => import("./views/store/orders"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/store/order/:id",
      component: () => import("./views/store/order"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/downloads",
      component: () => import("./views/downloads"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/faq",
      component: () => import("./views/faq"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/tickets",
      component: () => import("./views/tickets"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/tickets/:id",
      component: () => import("./views/tickets-view"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/courses",
      component: () => import("./views/courses/list"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/courses/:course",
      component: () => import("./views/courses/view"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/courses/:course/:module/:lesson",
      component: () => import("./views/courses/view"),
      meta: { authRequired: true, sponsored: 'any' },
    },
    {
      path: "/giftcards",
      component: () => import("./views/giftcards/list"),
      meta: { authRequired: true },
    },
    {
      path: "/giftcards/comprar",
      component: () => import("./views/giftcards/list"),
      meta: { authRequired: true },
    },
    {
      path: "/giftcards/purchases",
      component: () => import("./views/giftcards/purchases"),
      meta: { authRequired: true },
    },
    {
      path: "/giftcards/order/:id",
      component: () => import("./views/giftcards/order"),
      meta: { authRequired: true },
    },
    {
      path: "/giftcards/:slug",
      component: () => import("./views/giftcards/view"),
      meta: { authRequired: true },
    },
    {
      path: "/404",
      component: () => import("./views/404"),
      meta: { authRequired: false, sponsored: 'any' },
    },
    {
      path: "/:sponsor",
      redirect: "/register/:sponsor",
    },
    {
      path: "/:sponsor/:plan",
      redirect: "/register/:sponsor/:plan",
    },
  ],
});

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem("token");

  document.title = process.env.VUE_APP_TITLE
  next();

  if (to.meta.authRequired && !loggedIn) {
    return next("/login");
  }

  if (to.meta.authRequired && loggedIn) {
    api
      .get("user")
      .then((response) => {
        if (response.data && response.data.status == "success") {
          router.app.$store.state.account.user = response.data.user;

          if (
            response.data.user.contracts &&
            response.data.user.contracts.length > 0 &&
            to.path != "/contracts/" + response.data.user.contracts[0].id
          ) {
            response.data.user.contracts.forEach(con => {
              return next("/contracts/" + con.id);
            })
          }
        } else {
          return next("/login");
        }
      })
      .catch(error => {
        if (error) {
          return next("/login");
        }
      });
  } else {
    next();
  }
});

export default router;
